var React = require('react');

function M2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"M2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"47.9 40.28 40.51 24.05 29.56 0 0 83.68 33.05 82.3 66.11 80.93 66.39 80.92 47.9 40.28","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"96.34 86.78 65.19 5.24 47.1 38.71 58.95 87.25 96.34 86.78","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

M2.defaultProps = {"viewBox":"0 0 96.34 87.24"};

module.exports = M2;

M2.default = M2;
